import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getMultiNodeCourseQuery,
  getOrganizationCoursesQuery,
} from "./EntitySharingQueries";
import {
  organizationStaffFragment,
  organizationCoursesFragment,
} from "./EntitySharingFragments";

export const getOrganizationCoursesFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationCoursesQuery,
      variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getCourseFragmentFromCache = ({ id, variables }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Course:${id}`,
      fragment: organizationCoursesFragment.course,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getStaffFragmentFromCache = ({ id, variables }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Staff:${id}`,
      fragment: organizationStaffFragment.staff,
      fragmentName: "staff",
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getMultiNodeCourseFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getMultiNodeCourseQuery,
      variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "multiNode", []);
};
